function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import ReCAPTCHA from "react-google-recaptcha";
export class ReCaptchaForm extends React.Component {
    render() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                this.props.children,
                this.state.error != "" && /*#__PURE__*/ _jsx("div", {
                    className: "brf__errors",
                    role: "alert",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: "brf__error form__error text--xs",
                        children: this.state.error
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "brf__footer",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "brf__recaptcha",
                            children: /*#__PURE__*/ _jsx(ReCAPTCHA, {
                                ref: this.recaptchaRef,
                                sitekey: this.props.sitekey,
                                onChange: this.onReCapthcaChange,
                                onErrored: ()=>this.props.onErrored([
                                        {
                                            kind: "error",
                                            message: "Er is iets mis gegaan tijdens het initialiseren van het formulier. Herlaad de pagina opnieuw of neem contact op met De Nieuwe Bibliotheek."
                                        }
                                    ]),
                                onExpired: ()=>this.setState((s)=>({
                                            ...s,
                                            token: ""
                                        })),
                                badge: this.props.badge,
                                size: this.props.size,
                                type: "image",
                                theme: "light"
                            })
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "submit",
                            className: this.props.buttonClass,
                            disabled: this.props.buttonDisabled == undefined ? false : this.props.buttonDisabled,
                            onClick: (e)=>this.onSubmitCaptcha(e),
                            children: this.props.buttonText
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props), _define_property(this, "recaptchaRef", void 0), _define_property(this, "onReCapthcaChange", (token)=>{
            this.setState((s)=>({
                    ...s,
                    token: token,
                    error: ""
                }));
        }), _define_property(this, "onSubmitCaptcha", async (e)=>{
            e.preventDefault();
            const token = this.props.size != 'invisible' ? this.recaptchaRef.current.getValue() : await this.recaptchaRef.current.executeAsync();
            if (this.state.token == token && token != "" && this.state.token != "") {
                this.props.onSubmitOkay(e, token);
                this.setState((s)=>({
                        ...s,
                        token: ''
                    }));
            } else {
                this.setState((s)=>({
                        ...s,
                        token: '',
                        error: "Please complete the ReCaptcha"
                    }));
            }
            this.recaptchaRef.current.reset();
        });
        this.state = {
            token: "",
            error: ""
        };
        this.recaptchaRef = /*#__PURE__*/ React.createRef();
        this.onReCapthcaChange = this.onReCapthcaChange.bind(this);
        this.onSubmitCaptcha = this.onSubmitCaptcha.bind(this);
    }
}
